import React, { memo, ReactNode } from 'react';
import Avatar from 'assets/icons/Avatar.svg';

interface Props {
  NAME: string | ReactNode;
  URL: string;
  className?: string;
  textClassName?: string;
  style?: any;
}

export const PhotoNameCell = memo((props: Props) => {
  // Ensure NAME is a string for the tooltip; if it's a ReactNode, you might need to handle it differently.
  const nameString = typeof props.NAME === 'string' ? props.NAME : '';

  return (
    <div className={`!min-w-max ${props.className} !pl-0`}>
      <div className="flex items-center min-w-max gap-[4px]">
        <img
          src={props.URL || Avatar}
          className="!w-10 !h-10 rounded-full object-cover mx-0"
          alt="Student Photo"
        />
        <abbr title={nameString} className="no-underline">
          <h1
            className={` text-left font-medium w-fit truncate ${props.textClassName}`}
            // style={{ maxWidth: '100px' }} 
            style={props?.style}
          >
            {props.NAME}
          </h1>
        </abbr>
      </div>
    </div>
  );
});
